import React from 'react';
import { Button } from 'react-bootstrap';
import './index.scss';

import Icon from 'components/Icon';
import BottomPopup from 'containers/BottomPopup';

import { Props } from './types';

const IconButton: React.FC<Props> = ({
  children,
  text,
  shortCut,
  className,
  icons = [],
  action,
  ...props
}) => {
  return (
    <Button
      onClick={() => action?.()}
      className={`iconbutton ${className ?? ''}`}
      {...props}
    >
      {shortCut &&
        (icons.length === 0 ? (
          <span className="text-center">{shortCut}</span>
        ) : (
          <span className="shortcut-style">{shortCut}</span>
        ))}
      {(icons.length > 0 || text) && (
        <div
          className={`${
            icons?.length === 1 && !text ? 'd-block' : 'd-flex'
          } h-100 ${
            shortCut && shortCut.length > 0
              ? 'align-items-end'
              : 'align-items-center'
          } ${
            icons.length < 3 ? 'justify-content-end' : 'justify-content-around'
          } ${icons.length === 1 && !text && 'justify-content-center'}`}
        >
          <span className="maintext">{text}</span>

          {icons.map((icon, index) => (
            <span key={icon}>
              <Icon
                className={`medium-size ${icons.length === 2 ? 'mr-1' : ''}`}
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                name={icon}
              />
            </span>
          ))}
        </div>
      )}
      {children}
    </Button>
  );
};

export default IconButton;
